export const randomHexColor = (): string => {
  // 0x000000 .. 0xFFFFFF
  return `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, "0")}`;
}

export const rgbToHex = (r: number, g: number, b: number): string => {
  const toHex = (n: number) => n.toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export const randomHexNotTooLight = (options?: {
  // 0..1 (higher = lighter). ~0.75+ starts looking “pretty light”
  maxLuminance?: number;
  maxTries?: number;
}): string => {
  const maxLuminance = options?.maxLuminance ?? 0.72;
  const maxTries = options?.maxTries ?? 50;

  for (let i = 0; i < maxTries; i++) {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);

    // sRGB relative luminance (WCAG-ish)
    const toLinear = (c: number) => {
      const s = c / 255;
      return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    };
    const L =
      0.2126 * toLinear(r) +
      0.7152 * toLinear(g) +
      0.0722 * toLinear(b);

    if (L <= maxLuminance) return rgbToHex(r, g, b);
  }

  // fallback if we somehow keep hitting light colors
  return "#334155";
}